import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const SettingsIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={25} height={25} viewBox="0 0 25 25" fill="none" {...props}>
          <Path
            d="M20.8813 9.71945C19.0713 9.71945 18.3313 8.43945 19.2313 6.86945C19.7513 5.95945 19.4412 4.79945 18.5312 4.27945L16.8013 3.28945C16.0113 2.81945 14.9913 3.09945 14.5212 3.88945L14.4113 4.07945C13.5113 5.64945 12.0312 5.64945 11.1213 4.07945L11.0112 3.88945C10.5612 3.09945 9.54125 2.81945 8.75125 3.28945L7.02125 4.27945C6.11125 4.79945 5.80125 5.96945 6.32125 6.87945C7.23125 8.43945 6.49125 9.71945 4.68125 9.71945C3.64125 9.71945 2.78125 10.5694 2.78125 11.6194V13.3794C2.78125 14.4194 3.63125 15.2794 4.68125 15.2794C6.49125 15.2794 7.23125 16.5594 6.32125 18.1294C5.80125 19.0394 6.11125 20.1994 7.02125 20.7194L8.75125 21.7094C9.54125 22.1794 10.5613 21.8995 11.0312 21.1094L11.1412 20.9194C12.0412 19.3494 13.5212 19.3494 14.4312 20.9194L14.5413 21.1094C15.0113 21.8995 16.0313 22.1794 16.8213 21.7094L18.5513 20.7194C19.4613 20.1994 19.7712 19.0294 19.2512 18.1294C18.3412 16.5594 19.0813 15.2794 20.8913 15.2794C21.9313 15.2794 22.7913 14.4294 22.7913 13.3794V11.6194C22.7812 10.5794 21.9312 9.71945 20.8813 9.71945ZM12.7812 15.7494C10.9913 15.7494 9.53125 14.2894 9.53125 12.4994C9.53125 10.7094 10.9913 9.24945 12.7812 9.24945C14.5712 9.24945 16.0312 10.7094 16.0312 12.4994C16.0312 14.2894 14.5712 15.7494 12.7812 15.7494Z"
            fill={props.color || '#E08500'}
          />
        </Svg>
      </View>
    );
  },
);

export { SettingsIcon };
